module.exports = __webpack_public_path__ + "img/Greenmotion.d9715c74.gif";